import Layer from "../../utils/Layer";
import SceneView from "../../views/SceneView";
import BaseUI from "../BaseUI";
import KeyboardManager, { Key } from "../../utils/KeyboardManager";
import SpinModel from "../../model/SpinModel";
import GameModel from "../../model/GameModel";

export default abstract class AbstractPopup extends BaseUI {
    protected layer: Layer;
    protected scene: SceneView;

    constructor(){
        super();
        this.hidden = true;
    }

    public show(arg?) {
        this.hidden = false;
        KeyboardManager.onKey('pressed', Key.SPACE, this.hideFromKeyboard, this);
    }

    protected hideFromKeyboard() {
        if (GameModel.spaceToSpin) {
            this.hide();
        }
    }

    public hide() {
        this.hidden = true;
        this.clearInteractions();
        if (this.layer) {
            this.layer.clear();
            this.scene = null;
        }
        KeyboardManager.offKey('pressed', Key.SPACE, this.hideFromKeyboard, this);
    }

    public update(event: string) {};

    public toggle(arg?: any) {
        if (this.hidden) {
            this.show(arg);
        }
        else {
            this.hide();
        }
    }


}